import { render, staticRenderFns } from "./MissionFatCard.vue?vue&type=template&id=4629234a&scoped=true&"
import script from "./MissionFatCard.vue?vue&type=script&lang=js&"
export * from "./MissionFatCard.vue?vue&type=script&lang=js&"
import style0 from "./MissionFatCard.vue?vue&type=style&index=0&id=4629234a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4629234a",
  null
  
)

export default component.exports